import auth from './auth';
import router from '../router';
import axios from 'axios';
import qs from 'qs';

export default {
  api() {
    let api = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    });

    if (auth.isLoggedIn()) {
      api.defaults.headers.common['Authorization'] = `Bearer ${auth.getAccessToken()}`;
    }

    api.interceptors.response.use((response) => {
      return response
    }, (error) => {
      // redirect 401 errors to login page
      if (error.response && error.response.status == 401) {
        auth.logout();
        router.push('/login').catch(_err => {});
        router.go();
      }

      return Promise.reject(error);
    });

    return api;
  },
  get(url, parameters) {
    let queryString = '';
    if (parameters) {
      queryString += Object.keys(parameters).map(function(key) {
        if (Array.isArray(parameters[key])) {
          return (parameters[key].map(function (value) {
            return key + '=' + value;
          })).join('&');
        }
        else {
          return key + '=' + parameters[key];
        }
      }).join('&');

      url += "?" + queryString;
    }
    return this.api().get(url)
  },
  post(url, parameters) {
    return this.api().post(url, qs.stringify(parameters), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  postJSON(url, parameters) {
    return this.api().post(url, parameters);
  },
  put(url, parameters) {
    return this.api().put(url, parameters);
  },
  delete(url, parameters) {
    return this.api().delete(url, parameters);
  }
}
